import { tsValidateIsInRange, tsValidateString, tsValidateStringWithDashes, tsValidateUniqueId } from '@nu-art/ts-common';
import { PermissionDBGroup } from '../../consts.js';
const Validator_ModifiableProps = {
    domainId: tsValidateUniqueId,
    name: tsValidateStringWithDashes,
    uiLabel: tsValidateString(),
    value: tsValidateIsInRange([[0, 1000]]),
};
const Validator_GeneratedProps = {
    _auditorId: tsValidateString()
};
export const DBDef_PermissionAccessLevel = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'permissions--level',
    entityName: 'PermissionAccessLevel',
    frontend: {
        group: PermissionDBGroup,
        name: 'level',
    },
    backend: {
        name: 'permissions--level',
    },
    dependencies: {
        domainId: {
            dbKey: 'permissions--domain',
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map